function pad(num) {
  return ("0"+num).slice(-2);
}
export function hhmmss(secs) {
  var minutes = Math.floor(secs / 60);
  secs = secs%60;
  var hours = Math.floor(minutes/60)
  minutes = minutes%60;
  return `${pad(hours)}H ${pad(minutes)}M ${pad(secs)}S`;
  // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
}